<script>
import DateTime from '../../../functions/lib/dateTime.js';
import { queries } from '../../js/lib/functions.js';

export const pageName = 'admin-reports/newly-awarded';
export const pageRoute = '/admin/reports/newly-awarded';
export const title = 'Newly Awarded Members'
export const requireAdmin = true;

export default {
	data() {
		return { 
			threshold: null,
			message: null,
			ready: false
		}
	},
	methods: {
		async show(opts)
		{
			let messages = [];

			this.threshold = DateTime.today.addDays(-30);

			let users = (await queries.users.account.getRecentAwards({ thresholdOn: this.threshold })).users;

			let l1s = users.filter(u => u.certification.level1.passedOn >= this.threshold).map(u => u.name)
			if(l1s.length)
				messages.push((l1s.length > 1 ? (l1s.slice(0, -1).join(', ') + ' and ' + l1s.slice(-1)) : l1s[0]) + ' for passing their Level 1 HPR Certification');

			let l2s = users.filter(u => u.certification.level2.passedOn >= this.threshold).map(u => u.name)
			if(l2s.length)
				messages.push((l2s.length > 1 ? (l2s.slice(0, -1).join(', ') + ' and ' + l2s.slice(-1)) : l2s[0]) + ' for passing their Level 2 HPR Certification');

			let l3s = users.filter(u => u.certification.level3.passedOn >= this.threshold).map(u => u.name)
			if(l3s.length)
				messages.push((l3s.length > 1 ? (l3s.slice(0, -1).join(', ') + ' and ' + l3s.slice(-1)) : l3s[0]) + ' for passing their Level 3 HPR Certification');

			let modelRsos = users.filter(u => u.rso.model.grantedOn >= this.threshold).map(u => u.name)
			if(modelRsos.length)
				messages.push((modelRsos.length > 1 ? (modelRsos.slice(0, -1).join(', ') + ' and ' + modelRsos.slice(-1)) : modelRsos[0]) + ' for passing their Model RSO Certification');

			let l1Rsos = users.filter(u => u.rso.level1.grantedOn >= this.threshold).map(u => u.name)
			if(l1Rsos.length)
				messages.push((l1Rsos.length > 1 ? (l1Rsos.slice(0, -1).join(', ') + ' and ' + l1Rsos.slice(-1)) : l1Rsos[0]) + ' for passing their Level 1 RSO Certification');

			let l2Rsos = users.filter(u => u.rso.level2.grantedOn >= this.threshold).map(u => u.name)
			if(l2Rsos.length)
				messages.push((l2Rsos.length > 1 ? (l2Rsos.slice(0, -1).join(', ') + ' and ' + l2Rsos.slice(-1)) : l2Rsos[0]) + ' for passing their Level 2 RSO Certification');

			let l3Rsos = users.filter(u => u.rso.level3.grantedOn >= this.threshold).map(u => u.name)
			if(l3Rsos.length)
				messages.push((l3Rsos.length > 1 ? (l3Rsos.slice(0, -1).join(', ') + ' and ' + l3Rsos.slice(-1)) : l3Rsos[0]) + ' for passing their Level 3 RSO Certification');

			let mapas = users.filter(u => u.map.assessorGrantedOn >= this.threshold).map(u => u.name)
			if(mapas.length)
				messages.push((mapas.length > 1 ? (mapas.slice(0, -1).join(', ') + ' and ' + mapas.slice(-1)) : mapas[0]) + ' for passing their MAP Assessor Certification');

			let mapPromotions = users.filter(u => u.map.levelChangedOn >= this.threshold).map(u => u.name)
			if(mapPromotions.length)
				messages.push((mapPromotions.length > 1 ? (mapPromotions.slice(0, -1).join(', ') + ' and ' + mapPromotions.slice(-1)) : mapPromotions[0]) + ' for advancing their MAP rank');

			this.message = 'Congratulations to ' + (messages.length > 1 ? (messages.slice(0, -1).join(', ') + ' and ' + messages.slice(-1)) : messages[0]) + '.'

			this.ready = true;
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
	<div class="row justify-content-center py-5">
		<div class="col-12 col-md-8">
			<div class="card">
				<div class="card-header">
					<h4 class="card-header-title">Newly Awarded Members</h4>
				</div>
				<div class="card-body">
					<p class="selectable mb-0">{{ message }}</p>
				</div>
			</div>
		</div>
	</div>
</div>
</template>